import React from "react";

export const QueryModifierContext = React.createContext(undefined);
